import React from 'react';
import Card from '../ui/Card';

// Small KPI tile used across the Statistics page. Accents map to semantic tokens.
const accentClasses = {
  brand: 'text-brand bg-brand-soft',
  green: 'text-status-completed bg-status-completed-soft',
  red: 'text-status-canceled bg-status-canceled-soft',
  amber: 'text-status-pending bg-status-pending-soft',
  blue: 'text-status-confirmed bg-status-confirmed-soft',
};

const StatCard = ({ label, value, sublabel, icon: Icon, accent = 'brand' }) => {
  const accentClass = accentClasses[accent] || accentClasses.brand;

  return (
    <Card hover className="p-5 flex items-start justify-between animate-card-in">
      <div>
        <p className="text-sm font-medium text-muted">{label}</p>
        <p className="mt-1 text-2xl font-bold text-foreground">{value}</p>
        {sublabel && <p className="mt-1 text-xs text-muted-2">{sublabel}</p>}
      </div>
      {Icon && (
        <div className={`rounded-xl p-2.5 ${accentClass}`}>
          <Icon className="h-5 w-5" />
        </div>
      )}
    </Card>
  );
};

export default StatCard;
